import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';

/* Layout */
import MainLayout from './components/MainLayout';

/* Auth pages (no sidebar/header) */
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import EmailSuccessPage from './pages/EmailSuccessPage';

/* Standalone pages (no sidebar/header) */
import DocumentationPage from './pages/DocumentationPage';

/* Dashboard pages (wrapped in MainLayout) */
import DashboardPage from './pages/DashboardPage';
import ConversationsPage from './pages/ConversationsPage';
import ContactsPage from './pages/ContactsPage';
import PipelinePage from './pages/PipelinePage';
import SchedulingPage from './pages/SchedulingPage';
import SettingsPage from './pages/SettingsPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import UserSettingsPage from './pages/UserSettingsPage';
import APIHubPage from './pages/APIHubPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Auth routes (standalone, no sidebar) ── */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/email-success" element={<EmailSuccessPage />} />

        {/* ── Standalone pages (no sidebar/header) ── */}
        <Route path="/documentation" element={<DocumentationPage />} />

        {/* ── Dashboard routes (with sidebar + header layout) ── */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/conversations" element={<ConversationsPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/pipeline" element={<PipelinePage />} />
          <Route path="/scheduling" element={<SchedulingPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/user-settings" element={<UserSettingsPage />} />
          <Route path="/api-hub" element={<APIHubPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
